// src/admin/screens/borrowers/tabs/ProfileTab.tsx
// Renders the borrower's static profile fields. The schema stores
// address as a single free-text column (not line1 / city / province),
// so we show it verbatim.
import Card from '@admin/components/Card';
import { formatCatDateTime } from '@admin/utils/dates';
import { formatZambiaPhone } from '@admin/utils/phone';
import type { BorrowerDetail } from '@admin/hooks/useBorrower';

export default function ProfileTab({ borrower: b }: { borrower: BorrowerDetail }) {
  return (
    <Card title="Profile details">
      <dl
        style={{
          display: 'grid',
          gridTemplateColumns: '160px 1fr',
          gap: '8px 16px',
          margin: 0,
        }}
      >
        <dt>Display name</dt>
        <dd>{b.display_name ?? '—'}</dd>

        <dt>Full name</dt>
        <dd>{b.full_name ?? '—'}</dd>

        <dt>Phone</dt>
        <dd>{formatZambiaPhone(b.phone)}</dd>

        <dt>Email</dt>
        <dd>{b.email ?? '—'}</dd>

        <dt>NRC</dt>
        <dd>{b.nrc_number ?? '—'}</dd>

        <dt>Date of birth</dt>
        <dd>{b.date_of_birth ?? '—'}</dd>

        <dt>Gender</dt>
        <dd>{b.gender ?? '—'}</dd>

        <dt>Address</dt>
        <dd>{b.address ?? '—'}</dd>

        <dt>Joined</dt>
        <dd>{formatCatDateTime(b.created_at)}</dd>
      </dl>
    </Card>
  );
}
